document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".shopify-section--featured-product")
    .forEach((featuredProductSection) => {
      const videoList = featuredProductSection.querySelectorAll("video");

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute("poster", entry.target.dataset.poster);
            entry.target.lastElementChild.setAttribute(
              "src",
              entry.target.lastElementChild.dataset.src,
            );
          }
        });
      });

      videoList.forEach((video) => {
        videoObserver.observe(video);

        video.addEventListener("click", (event) => {
          const pausedVideo = !video.hasAttribute("data-play");

          videoList.forEach((video) => {
            video.pause();
            video.removeAttribute("data-play");
          });

          if (pausedVideo) {
            video.setAttribute("data-play", "");
            setTimeout(() => video.play(), 100);
          }
        });
      });

      featuredProductSection.addEventListener("click", (event) => {
        const eventPath = event.composedPath
          ? event.composedPath().slice(0, -2)
          : [];

        for (const element of eventPath) {
          const clickAction = element.getAttribute("data-click-action");
          if (!clickAction) continue;

          if (clickAction === "update-product-gallery") {
            updateProductGallery(element, featuredProductSection);
            break;
          } else if (clickAction === "update-product-variant") {
            updateProductVariant(element, featuredProductSection);
            break;
          } else if (clickAction === "add-featured-product-to-cart") {
            addFeaturedProductToCart(element, featuredProductSection);
            break;
          } else if (clickAction === "scroll-to-destination") {
            scrollToDestination(element, featuredProductSection);
            break;
          } else if (clickAction === "toggle-quick-link-content") {
            toggleQuickLinkContent(element, featuredProductSection);
            break;
          } else if (clickAction === "click-main-add-to-cart") {
            const addToCartButton = featuredProductSection.querySelector(
              ".add-to-cart-button",
            );
            addFeaturedProductToCart(addToCartButton, featuredProductSection);
            break;
          } else if (clickAction === "scroll-to-product-options") {
            const productOptions = featuredProductSection.querySelector(
              ".product-variant-list",
            );
            if (!productOptions) return;

            productOptions.scrollIntoView({ behavior: "smooth" });
          }
        }
      });

      const addToCartButton = featuredProductSection.querySelector(
        ".add-to-cart-button",
      );
      const stickyAddToCartContainer = featuredProductSection.querySelector(
        ".sticky-add-to-cart-container",
      );

      if (addToCartButton && stickyAddToCartContainer) {
        const addToCartButtonObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                stickyAddToCartContainer.removeAttribute("data-active");
              } else {
                stickyAddToCartContainer.setAttribute("data-active", "");
              }
            });
          },
          { rootMargin: "-100px 0px 400px 0px" },
        );

        addToCartButtonObserver.observe(addToCartButton);
      }
    });
});

function updateProductGallery(galleryButton, section) {
  const galleryHandle = galleryButton.parentElement.getAttribute(
    "data-gallery-handle",
  );

  const galleryContainerList = section.querySelectorAll(
    ".product-gallery-container",
  );

  galleryContainerList.forEach((galleryContainer) => {
    galleryContainer.getAttribute("data-gallery-handle") === galleryHandle
      ? galleryContainer.setAttribute("data-active", "")
      : galleryContainer.removeAttribute("data-active");
  });

  const galleryButtonList = section.querySelectorAll(".gallery-choice");

  galleryButtonList.forEach((button) => {
    const galleryChoiceContainer = button.parentElement;

    galleryChoiceContainer === galleryButton.parentElement
      ? galleryChoiceContainer.setAttribute("data-active", "")
      : galleryChoiceContainer.removeAttribute("data-active");
  });
}

function updateProductVariant(variantButton, section) {
  const addToCartButton = section.querySelector(".add-to-cart-button");
  if (!addToCartButton) return;

  const variantId = variantButton.getAttribute("data-variant-id");

  addToCartButton.setAttribute("data-variant-id", variantId);

  const variantCardList = section.querySelectorAll(".product-variant-card");
  variantCardList.forEach((card) => {
    card === variantButton
      ? card.parentElement.setAttribute("data-active", "")
      : card.parentElement.removeAttribute("data-active");
  });
}

async function addFeaturedProductToCart(addToCartButton, section) {
  try {
    const variantId = addToCartButton.getAttribute("data-variant-id");

    const cartSectionId = document
      .querySelector(".shopify-section--cart-drawer")
      .id.split("shopify-section-")
      .pop();
    const addToCartBody = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: [cartSectionId],
    };

    const addToCartJson = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addToCartBody),
    }).then((response) => response.json());

    refreshCartUserInterface(addToCartJson.sections[cartSectionId]);
  } catch (error) {
    console.error("Error adding the recommendation product to the cart", error);
  }
}

function scrollToDestination(destinationButton, section) {
  const destination = destinationButton.getAttribute("data-destination");
  const destinationElement = document.querySelector(`#${destination}`);
  if (!destinationElement) return;

  const associatedSection = destinationElement.parentElement;

  associatedSection.scrollIntoView({ behavior: "smooth" });
}

function toggleQuickLinkContent(quickLinkTitle, section) {
  const quickLinkContainer = quickLinkTitle.parentElement;
  if (!quickLinkContainer) return;

  quickLinkContainer.hasAttribute("data-active")
    ? quickLinkContainer.removeAttribute("data-active")
    : quickLinkContainer.setAttribute("data-active", "");
}
